import { useEffect } from "react";
import { useDrag } from "react-dnd";
import { setDragging } from "./dragDrop";
import { Avatar, Chip } from "@mui/material";
import { useAppDispatch } from "../../app/hooks";
import { groupRemoveUser } from "../../features/daoTrang/daoTrangSlice";
import { stringAvatar } from "../To/UserChip";

export function DragUser({ user: user, container: container }) {
  const [{ isDragging }, drag] = useDrag(() => ({
    type: "OrderCard",
    collect: (monitor) => ({
      isDragging: !!monitor.isDragging(),
    }),
  }));
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (isDragging) {
      setDragging({ user, container });
    }
  }, [isDragging, user, container]);

  function handleDelete() {
    dispatch(groupRemoveUser({ user, container }));
  }

  var l = stringAvatar(user.name);
  var avatar = <Avatar {...l}></Avatar>;
  var m = user.address.match(/\w+/)
  var tinh = m?"-" + m[0]:"";
  return (
    <div
      ref={drag}
      style={{
        opacity: isDragging ? 0.5 : 1,
        cursor: "move",
      }}
    >
      <Chip
        label={user.name + tinh }
        variant="outlined"
        onDelete={handleDelete}
        avatar={avatar}
      />
    </div>
  );
}
